import { TextDecorationType } from '@kubit/web-ui-components/text/types';
import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
import { POSITIONS } from '@kubit/web-ui-components/types/positions';
import { FONT_WEIGHT } from '../../foundations/typography';
import { PopoverVariantType } from '../popover/variants';
import { LinkVariantType, TextVariantType } from '../variants';
export const commonStyles = (FOUNDATIONS, FONT) => ({
    container: {
        box_shadow: `${FOUNDATIONS.spacing_00} ${FOUNDATIONS.spacing_75} ${FOUNDATIONS.blur_50} ${FOUNDATIONS.spread_negative_50} ${FOUNDATIONS.color_effect_shadow_drop_150}`,
        padding: `${FOUNDATIONS.spacing_200} ${FOUNDATIONS.spacing_250}`,
        border_radius: FOUNDATIONS.radius_comp_feedback_snackbar_radiussize,
        background_color: FOUNDATIONS.color_comp_feedback_snackbar_success_bg,
        border_style: 'solid',
        border_width: FOUNDATIONS.border_comp_feedback_snackbar_bordersize,
        display: 'flex',
        gap: FOUNDATIONS.spacing_150,
        min_height: '3rem',
        max_width: '100vw',
        [DeviceBreakpointsType.DESKTOP]: { max_width: FOUNDATIONS.size_1238 },
        [DeviceBreakpointsType.TABLET]: { max_width: FOUNDATIONS.size_1225 },
    },
    iconTitleContainer: {
        display: 'flex',
        flex_direction: 'row',
        gap: FOUNDATIONS.spacing_150,
    },
    icon: {
        width: FOUNDATIONS.size_300,
        height: FOUNDATIONS.size_300,
    },
    title: {
        font_variant: TextVariantType.FONT_PARAGRAPH_350,
        font_weight: FONT_WEIGHT.font_regular,
        color: FOUNDATIONS.color_neutral_font_onsurface_50,
    },
    closeIcon: {
        color: FOUNDATIONS.color_neutral_icon_onsurface_50,
        width: FOUNDATIONS.size_300,
        height: FOUNDATIONS.size_300,
    },
    link: {
        variant: LinkVariantType.SECONDARY_ON_SURFACE,
        decoration: TextDecorationType.UNDERLINE,
    },
    popoverVariants: {
        [POSITIONS.TOP_CENTER_FIXED]: PopoverVariantType.SNACKBAR_TOP,
        [POSITIONS.BOTTOM_CENTER_FIXED]: PopoverVariantType.SNACKBAR_BOTTOM,
    },
});
//# sourceMappingURL=commonStyles.js.map